import * as yup from 'yup';
import { API as handoverAPI } from '../api';
import { API as yachtsAPI } from '../../yachts/api';
import { API as usersNauticaAPI } from '../../users_nautica/api';

import dayjs from 'dayjs';

export const TypeOptions = [
    { label: 'PROGRAMMA BARCA', id: 'PROGRAMMA BARCA', width: 180, },
    { label: 'REMINDER', id: 'REMINDER', width: 180 },
    { label: 'FEEDBACK', id: 'FEEDBACK', width: 180 },
    { label: 'CHIUSURA CONTO', id: 'CHIUSURA CONTO', width: 180 },
    { label: 'ACTION', id: 'ACTION', width: 180 },
];

export const PriorityOptions = [
    { label: 'URGENT', id: 'URGENT' },
    { label: 'MEDIUM', id: 'MEDIUM' },
    { label: 'LOW', id: 'LOW' },
];

export const StatusOptions = [
    { label: 'OPEN', id: 'OPEN' },
    { label: 'CLOSED', id: 'CLOSED' },
];

export const CreateConf = {
    schema: yup.object({
        id_department: yup.mixed().nullable(),
        id_team: yup.mixed().nullable(),
        id_yacht: yup.mixed().nullable(),
        assignee_user_id: yup.mixed().nullable(),

        type: yup.object().nullable().required('Type is required'),
        priority: yup.object().nullable().required('Priority is required'),
        status: yup.object().nullable().required('Status is required'),
        date: yup.string().nullable()
            .test(
                "valid-date",
                "Invalid date",
                (value) => {
                    if (!value) return true;
                    return dayjs(value).isValid();
                }
            ),

        title: yup
            .string()
            .max(255, 'Title is too long (max 255 characters)')
            .required('Ticket Title is required'),
        description: yup.string().required('Ticket Description is required'),
    }),

    defaultValues: {
        id_department: null,
        id_team: null,
        id_yacht: null,
        assignee_user_id: null,
        type: null,
        priority: { label: 'MEDIUM', id: 'MEDIUM' },
        status: { label: 'OPEN', id: 'OPEN' },
        date: null,
        title: '',
        description: '',
    },

    fields: [
        {
            id: 'type',
            name: 'type',
            type: 'autocomplete',
            label: 'Type',
            options: TypeOptions,
            required: true,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'id_department',
            name: 'id_department',
            type: 'async_autocomplete',
            label: 'Department',
            api: handoverAPI.departments,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'id_team',
            name: 'id_team',
            type: 'async_autocomplete',
            label: 'Team',
            api: handoverAPI.teams,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'id_yacht',
            name: 'id_yacht',
            type: 'yacht_form',
            label: 'Yacht',
            api: yachtsAPI.selectNoDRAFT,
            required: false,
            hasDivider: false,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'assignee_user_id',
            name: 'assignee_user_id',
            type: 'async_autocomplete',
            label: 'Assignee',
            api: usersNauticaAPI.selectName,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'priority',
            name: 'priority',
            type: 'autocomplete',
            label: 'Priority',
            options: PriorityOptions,
            required: true,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'status',
            name: 'status',
            type: 'autocomplete',
            label: 'Status',
            options: StatusOptions,
            required: true,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'date',
            name: 'date',
            type: 'date',
            label: 'Date',
            required: false,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'title',
            name: 'title',
            type: 'text',
            label: 'Title',
            required: true,
            xs: 12,
        },
        {
            id: 'description',
            name: 'description',
            type: 'text_multiline',
            label: 'Description',
            required: true,
            xs: 12,
            rows: 10,
        },
    ],
};